module.exports = __webpack_public_path__ + "img/test_cat_bottom.691e5eb6.png";